import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { escapeHtml, rescueHtml } from './Tools';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { ReactComponent as Add } from '../Img/icon-add.svg';
import ModalUpdateUser from './ModalUpdateUser';

const InvitUser = (props) => {
    const [aff, setAff] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [type_users, setType_users] = useState([]);
    const [userFocus, setUserFocus] = useState(null);
    const [mail, setMail] = useState('');
    const [userType, setUserType] = useState('');
    const [organisme, setOrganisme] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const green = '#59B44A';


    useEffect(() => {
        
        if (props.type_users && props.type_users.length > 0) {
            var tmp2 = [];
            for (let i = 0; i < props.type_users.length; i++) {
                tmp2[i] = {
                    id: props.type_users[i].id,
                    nom: props.type_users[i].type_user || props.type_users[i].nom // Fallback au cas où la colonne s'appelle différemment
                }
            }
            setType_users(tmp2);
        }
    }, [props.type_users])

    useEffect(() => {
        if (props.organismes && props.organismes.length > 0 && props.type_users && props.type_users.length > 0) {
            setIsLoading(false);
        }
    }, [props.organismes, props.type_users])

    function makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    function getDroits(id_user)
    {
        var params = {
            'getDroits': true,
            'id_user': id_user
        }
        return axios.post('https://app-slfinance.fr/api/droits.php', qs.stringify(params))
        .then((res) => {
            if (res.data['status'] === 1) {
                return (res.data.droits);
            }
            else {
                return [];
            }
        })
        .catch((err) => {
            console.warn(err);
            return [];
        });
    }

    function handleInvite() {
        const token = makeid(80);
        let type = userType === "" ? "1" : userType;
        if (mail) {
            if (type === "2" && organisme === "") {
                NotificationManager.warning('Veuillez renseigner l\'organisme', '', 2000);
            } else {
                if ((type === '1' && mail.includes('strategies-locales.fr')) || (type !== '1')) {
                    const url = 'https://app-slfinance.fr/api/users.php';
                    const params = {
                        'createUser': true,
                        'email': escapeHtml(mail),
                        'token': token,
                        'id_type_users': type,
                        'id_organisme': organisme,
                        'sendmail': true,
                        'url': window.location.host
                    }
                    axios.post(url, qs.stringify(params))
                        .then((res) => {
                            if (res.data['status'] === 1) {
                                NotificationManager.success('Utilisateur invité', '', 700);
                                axios.post("https://app-slfinance.fr/api/users.php", qs.stringify({ 'getUsers': true, 'id': res.data.user_id }))
                                .then(async(result) => {
                                    await getDroits(res.data.user_id)
                                    .then(async (r) => {
                                        result.data[0].droits = r;
                                        await setUserFocus(result.data[0]);
                                        await setModalVisible(true);
                                        await setAff(!aff);
                                    })
                                })
                                .catch((err) => {
                                    console.warn(err)
                                })
                                setUserFocus(res.data.user_id);
                                setAff(!aff);
                                setModalVisible(true);
                            }
                            else {
                                NotificationManager.warning(res.data['status_message'], '', 2000);
                            }
                        })
                        .catch((err) => {
                            console.warn(err)
                        })
                }
                else {
                    NotificationManager.warning('Seul les utilisateurs SL peuvent avoir ce status', '', 5000);
                }
            }
        }
        else {
            NotificationManager.warning("Veuillez renseigner l'email", '', 2000);
        }
    }

    return (
        <div className='shadow-xl' style={{ textAlign: 'center', borderRadius: 3, padding: 5, margin: 1, backgroundColor: 'white' }}>
            <NotificationContainer />

            {userFocus &&
                <ModalUpdateUser
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    user={userFocus}
                    who={props.user ? props.user.id : null}
                />
            }

            <p>Inviter un utilisateur :</p>
            {isLoading ? (
                <div style={{margin: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200}}>
                    <div className='spinner' style={{
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #6571FE',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        animation: 'spin 1s linear infinite'
                    }}>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
            ) : (
            <div style={{ textAlign: 'left' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ margin: 10 }}>
                        <input
                            className='shadow-md'
                            style={{ width: 250 }}
                            placeholder='Email'
                            value={mail}
                            onChange={e => setMail(e.target.value)}
                        />
                    </div>
                    <div style={{ margin: 10 }}>
                        <select
                            className='shadow-md'
                            style={{ width: 250, padding: 5 }}
                            value={userType}
                            onChange={e => setUserType(e.target.value)}
                        >
                            <option value="">...</option>
                            {type_users.map((user) =>
                                <option key={user['id']} value={user['id']}>{user['nom']}</option>
                            )}
                        </select>
                    </div>

                    <div style={{ margin: 10 }}>
                        <select
                            className='shadow-md'
                            style={{ width: 250, padding: 5 }}
                            value={organisme}
                            onChange={e => setOrganisme(e.target.value)}
                        >
                            <option value="">...</option>
                            {props.organismes.map((organisme) =>
                                <option key={organisme['id']} value={organisme['id']}>{rescueHtml(organisme['nom'])}</option>
                            )}
                        </select>
                    </div>

                    <div style={{ margin: 10, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <button
                            type="button"
                            style={{ display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, paddingLeft: 10, border: 'none', cursor: 'pointer', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}
                            onClick={handleInvite}
                        >
                            <Add width="12" />
                            <p style={{ marginLeft: 5, fontSize: 14, paddingLeft: 5, paddingRight: 15 }}>Inviter</p>
                        </button>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
}

export default InvitUser;
